import List from 'list.js'
import { addListener } from '../common/events'

const ListComp = () => {
  const l = new List('wwp3-list', {
    listClass: 'wwp3-jsl-list',
    valueNames: [
      'wwp3-jsl-name',
      { data: ['branches', 'has-offers', 'has-events', 'zip', 'city'] },
    ],
  })

  addListener('.js-wwp3-filter-clear', 'click', evt => {
    evt.preventDefault()
    l.filter()
    l.search('')
  })

  addListener('.js-wwp3-filter-link', 'click', evt => {
    evt.preventDefault()
    const f = evt.target.getAttribute('data-filter')
    l.filter()
    l.filter(item => item.values()[f] >= 1)
  })

  addListener('.js-wwp3-filter-search', 'click', evt => {
    evt.preventDefault()
    l.filter()
    l.search(evt.target.getAttribute('data-filter-val'))
  })

  // addListener('.js-wwp3-filter-zip', 'click', evt => {
  //   evt.preventDefault()
  //   l.search(evt.target.getAttribute('data-filter-val'))
  // })
}

export default ListComp



// WEBPACK FOOTER //
// src/assets/js/front-end/components/list.js